import React from "react";
import { useTranslation, } from "react-i18next";

import NavigationLink from "./Link";

const NavigationMenu = ({ headerPaths, }) => {
  const { i18n, } = useTranslation();
  const lang = i18n.language || "ky";

  return (
    <>
      {headerPaths.slice(0, 6).map((item, i) => (<NavigationLink classess={lang === "ky" ? "linkItemForKy" : "linksItem"} key={i} url={item.url} name={item.name}/>))}
    </>
  );

};

export default NavigationMenu;
